import { connect } from 'react-redux';

import { getPricePerNightPerPerson } from 'src/routes/Hotel/store/selectors/common';

import { getHotelId, getHotelTitle } from 'src/routes/Hotel/store/hotel';
import { LazyExpensiveHotelsPopup } from './LazyExpensiveHotelsPopup';

const mapStateToProps = (state) => ({
  pricePerNightPerPerson: getPricePerNightPerPerson(state),
  hotelId: getHotelId(state),
  title: getHotelTitle(state),
});

const connector = connect(mapStateToProps);

export default connector(LazyExpensiveHotelsPopup);
